import { render } from "./Motivos.vue?vue&type=template&id=44779f08&scoped=true"
const script = {}

import "./Motivos.vue?vue&type=style&index=0&id=44779f08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44779f08"]])

export default __exports__